import { useSearchQuery } from 'src/hooks/useSearchQuery'
import { IListItem } from '../useStorageObjects'

export const ComposeModal = 'composeModal'
export interface IComposeParams {
  emailId?: number
  addresseParams?: {
    storageObjects?: IListItem[]
    values?: string[]
  }
  scheme?: string
  subject?: string
  contentInsert?: string
}

export interface IUseRoutermailPageSearchQuery {
  mailPage?: {
    threadId?: string
    filteringParams?: ISelectedFilterParams
    selectedMailThreadsIds?: string[]
    showSettings?: boolean

    composeParams?: IComposeParams

    mobileEmailDrawer?: boolean
  }
}

export interface ISelectedFilterParams {
  labels?: string
  search?: string
  emails?: string
  page?: number
}

export const useRouterMailPage = () => {
  const search = useSearchQuery<
    IUseRoutermailPageSearchQuery & { modal?: string }
  >()

  const selectMailThreadId = (id?: string) => {
    search.setQuery({
      mailPage: {
        ...search.query.mailPage,
        threadId: id,
      },
    })
  }

  const selectMailFilteringParams = (
    filteringParams: ISelectedFilterParams
  ) => {
    search.setQuery({
      mailPage: {
        ...search.query.mailPage,
        threadId: undefined,
        filteringParams: {
          ...search.query.mailPage?.filteringParams,
          ...filteringParams,
        },
      },
    })
  }

  const selectMobileDrawerState = (state?: boolean) => {
    search.setQuery({
      mailPage: {
        ...search.query.mailPage,
        mobileEmailDrawer: state,
      },
    })
  }

  const selectMailThreadsIds = (threadIds?: string[]) => {
    search.setQuery({
      mailPage: {
        ...search.query.mailPage,
        selectedMailThreadsIds: threadIds,
      },
    })
  }

  const selectMailComposeParams = (composeParams?: IComposeParams) => {
    search.setQuery({
      mailPage: {
        ...search.query.mailPage,
        composeParams,
      },
    })
  }

  const showSettingsPage = (arg?: boolean) => {
    search.setPathQuery('/email', {
      mailPage: {
        ...search.query.mailPage,
        showSettings: arg,
      },
    })
  }

  const handleOpenThreadModal = (threadId: string) => {
    search.setQuery({
      modal: 'messageData',
      mailPage: { ...search.query.mailPage, threadId },
    })
  }

  const handleCompose = (composeParams: IComposeParams) => {
    search.setQuery({
      modal: 'composeModal',
    })
    selectMailComposeParams(composeParams)
  }

  const handleCloseModal = () => {
    search.removeQuery(['modal'])
  }

  const handleReload = () => {
    search.setQuery({
      mailPage: {
        ...search.query.mailPage,
        threadId: undefined,
        selectedMailThreadsIds: undefined,
        filteringParams: {
          ...search.query.mailPage?.filteringParams,
          page: undefined,
        },
        mobileEmailDrawer: undefined,
      },
    })
  }

  const close = () => {
    search.removeQuery(['mailPage'])
  }

  return {
    search,
    ...search.query.mailPage,

    selectMobileDrawerState,
    handleOpenThreadModal,
    handleCompose,
    selectMailComposeParams,
    selectMailThreadsIds,
    handleCloseModal,
    selectMailThreadId,
    selectMailFilteringParams,
    showSettingsPage,
    handleReload,
    close,
  }
}
